import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/gym/$venueUuid/events/$competitionUuid/")({
  loader: () => {
    throw redirect({
      to: "./profile/details",
      from: "/gym/$venueUuid/events/$competitionUuid/",
    });
  },
});
